<!-- <p>product-basic-info works!</p> -->
<div class="similar_products flex justify-start items-center md:hidden">
	<button *ngIf="dataProductBasicInfo.specialStatus">
		{{dataProductBasicInfo.specialStatus.name}}
	</button>
</div>
<div class="basic_product_details_cont">
	<h1>
		<!-- HERRINGBONE NAVY PURE WOOL HANDWOVEN FABRIC -->
		{{dataProductBasicInfo.name}}
	</h1>
	<div class="price_and_product_cont">
		<p class="price">
			{{selectedCurrency | uppercase}}


			<span class="price_span {{storediscountedPrice?'cross':''}}">{{undiscountedPrice |  currencyConverter | number: '1.0-2'}}</span>

			<ng-container *ngIf="storediscountedPrice">
				{{(storediscountedPrice) |  currencyConverter | number: '1.0-2'}}
			</ng-container>
			/   {{dataProductBasicInfo.unit }}
			<br />
		</p>
		<div>
			<p class="product_code">Product Code: {{dataProductBasicInfo.sku}}</p>
		</div>

	</div>
</div>
